import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
class HomeDiptychProducts extends Component {
    constructor(el, options) {
        super(el, options);
    }
    initialized() {
        super.initialized();
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.slider[method]('scroll', this.onScroll);
    }
    onScroll = () => {
        const progress = this.refs.slider.scrollLeft / (this.refs.slider.scrollWidth - this.refs.slider.clientWidth);
        this.refs.track.style.transform = `translateX(${progress * (100) * (this.refs.items.length - 1)}%)`;
    };
    resize() {
        super.resize();
    }
}
export default HomeDiptychProducts;
